import { Navigate, useLocation } from "react-router-dom";

export default function FacilityDetailsIndexPage() {
  const location = useLocation();
  return <Navigate to={`${location.pathname}/contact`} replace />;
}
